__turbopack_context__.v({
  "header": "LogoHeader-module-scss-module__h3w-hW__header",
  "logo-container": "LogoHeader-module-scss-module__h3w-hW__logo-container",
  "logo-image": "LogoHeader-module-scss-module__h3w-hW__logo-image",
});
